import { render } from "./ReceiptUploadForm.vue?vue&type=template&id=35ddc9b7&ts=true"
import script from "./ReceiptUploadForm.vue?vue&type=script&lang=ts"
export * from "./ReceiptUploadForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__